import React from "react";
import { useChatInputView } from "../hooks/presentation/useChatInputView";
import Prompt from "../../../components/input/Prompt/Prompt";
import { Mode } from "../types";
import Btn from "../../../components/btn";

interface PromptContainerProps {
  stopTts?: () => void;
}

const PromptContainer: React.FC<PromptContainerProps> = ({ stopTts }) => {
  const { promptProps, showPrompt, showLoginButton, handleLoginClick } =
    useChatInputView({
      mode: Mode.TUTOR,
      stopTts,
    });

  return showPrompt ? (
    <Prompt {...promptProps} className="w-full"/>
  ) : (
    showLoginButton && (
      <Btn.Primary onClick={handleLoginClick}>로그인 후 질문하기</Btn.Primary>
    )
  );
};

export default PromptContainer;
